module.exports = __webpack_public_path__ + "static/media/home6.44293406.jpg";